import React from "react";
import "../styles/About.css";
import { FaCheckCircle } from "react-icons/fa";
import Reveal from "../components/Reveal";

const About: React.FC = () => {
  return (
    <div className="about-container">
      <Reveal variant="fade-down" duration={600}>
        <div className="breadcrumb">ANASAYFA / HAKKIMIZDA</div>
      </Reveal>

      <Reveal variant="zoom" duration={700} delay={100}>
        <img src={require("../assets/images/log3.png")} alt="Logo" className="about-logo enlarged-logo" />
      </Reveal>

      <Reveal variant="fade-up" duration={600}>
        <h2 className="about-section-title">Hakkımızda</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />ATS DÖVİZ hem kurumsal hem de bireysel anlamda müşterilerine nakit ve banka hesapları üzerinden (Hesaba Havale , Eft ve Yurtiçi Bankalara Transfer) döviz alım-satım hizmeti sunmaktadır. Yeniden şekillenen ülke ekonomisi, uluslararası piyasalarda hem ithalatı hem de ihracatıyla önemli olan bir aktör konumuna gelmiş, yeni gelişen bu durum bilhassa finans sektöründe daha yenilikçi ve rekabetçi bir yaklaşımı zorunlu kılmıştır.</p>
      </Reveal>

      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />ATS DÖVİZ olarak güçlü öz sermayemiz ve nitelikli iş gücümüzle döviz piyasalarında ihtiyaç duyduğunuz "iyi fiyat-tam hizmeti vermekte kararlıyız. Siz de bankaların tek boyutlu işlem anlayışından daha fazlasını istiyorsanız gerçek müşteri odaklı "private marketing" yaklaşımımızda her zaman size özel çözümler bulacaksınız... "Hesaba havale-eft, güvenlikli kurye işlemleri ve daha fazlası için sizlerle birlikteyiz."</p>
      </Reveal>

      <Reveal variant="fade-right" duration={600}>
        <h2 className="about-section-title">Firmamız A grubu yetkili müessese olarak faaliyet göstermektedir.</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />ATS Döviz her zaman müşterilerinin yanındadır, bizimle çalışmanın avantajlarını kaçırmayın!</p>
      </Reveal>

      <Reveal variant="fade-right" duration={600}>
        <h2 className="about-section-title">Hızlı İşlem Oluşturma</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />Telefon aracılığı ile sipariş verebilir, bunlara ilişkin alım ve satım işlemlerini en hızlı şekilde yaptırabilirsiniz.</p>
      </Reveal>

      <Reveal variant="fade-right" duration={600}>
        <h2 className="about-section-title">Güvenlik Seçenekleri</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />Varlıklarınızı ofisinize veya istediğiniz bir bankaya zırhlı servis araçlarımız ile getirtebilirsiniz.</p>
      </Reveal>

      <Reveal variant="fade-right" duration={600}>
        <h2 className="about-section-title">Yüksek Kazanç</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />Özel kur opsiyonlarını seçerek, birikimlerinizde daha kazançlı yatırım olanağı sağlayabilirsiniz.</p>
      </Reveal>

      <Reveal variant="fade-right" duration={600}>
        <h2 className="about-section-title">Kolay Ve Hızlı Ödeme Yöntemleri</h2>
      </Reveal>
      <Reveal variant="fade-up" duration={600} delay={80}>
        <p className="about-text"><FaCheckCircle className="icon gold-icon" />Havale, EFT (banka veya Merkez Bankası), nakit yolları ile ofise, bankaya veya iş yerlerinize servis ile gerçekleştirebilme kolaylığını sunmaktadır.</p>
      </Reveal>
    </div>
  );
};

export default About;
